import { Box, Typography } from "@mui/material";
import { principlePresentation } from "@chessla/shared";
import { typographyTokens } from "@/shared/theme";
import { formatMotif } from "../format";
import { DetectedSignalRail, PatternMovementRail } from "../components/EvidenceRail";
import type { PatternExplorerItem } from "../pattern-explorer";
import { tacticalEvidenceSummary } from "../pattern-copy";

export const explorerItemTitle = (item: PatternExplorerItem) =>
  item.kind === "tactical"
    ? formatMotif(item.pattern.motif)
    : item.kind === "principle"
      ? principlePresentation(item.pattern.principle).name
      : item.title;

/** One list row: name, how many games it touched, and its recent movement. */
export const PatternExplorerRow = ({ item, analyzedGames }: { item: PatternExplorerItem; analyzedGames: number }) => {
  if (item.kind === "moment")
    return (
      <Box sx={{ pr: 8 }}>
        <Typography sx={{ fontWeight: "fontWeightBold", letterSpacing: typographyTokens.tracking.heading }}>
          {item.title}
        </Typography>
        <Typography sx={{ color: "text.secondary", fontSize: "caption.fontSize" }}>
          {item.note} · {item.examples.length} {item.examples.length === 1 ? "position" : "positions"}
        </Typography>
      </Box>
    );
  const games =
    item.kind === "tactical"
      ? (item.pattern.volume?.affectedGames ?? item.pattern.gameCount)
      : item.pattern.affectedGames;
  const moments = item.kind === "tactical" ? item.pattern.count : item.pattern.missedCount;
  const evidence =
    item.kind === "tactical" ? tacticalEvidenceSummary(item.pattern.motif, item.pattern.examples[0]?.evidence) : null;
  return (
    <Box sx={{ pr: 8 }}>
      <Typography sx={{ fontWeight: "fontWeightBold", letterSpacing: typographyTokens.tracking.heading }}>
        {explorerItemTitle(item)}
      </Typography>
      <Typography sx={{ color: "text.secondary", fontSize: "caption.fontSize" }}>
        {games} of {item.pattern.volume?.analyzedGames ?? analyzedGames} games · {moments}{" "}
        {moments === 1 ? "moment" : "moments"}
      </Typography>
      {evidence && <Typography sx={{ fontSize: "caption.fontSize" }}>{evidence}</Typography>}
      {item.kind === "tactical" ? (
        <PatternMovementRail movement={item.pattern.movement} />
      ) : (
        <DetectedSignalRail
          missed={item.pattern.missedCount}
          applied={item.pattern.appliedCount}
          interval={item.pattern.volume.interval95}
        />
      )}
    </Box>
  );
};
